import { Chip } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  root: {
    backgroundColor: '#CFEDF6',
    color: '#0A5672',
    height: '1.188rem',
    width: '2.5rem',
    marginRight: '0.313rem',
    '& .MuiChip-label': {
      paddingLeft: '0',
      paddingRight: '0',
    },
  },
});

const PDChip = () => {
  const { classes } = useStyles();

  return (
    <>
      <Chip className={classes.root} label="PD" title="POS Developer" />
    </>
  );
};

export default PDChip;
